import React, { Component } from 'react';
import {
  Layout,
  Col,
  Button,
  Row,
  Modal,
  Divider,
  Input,
  DatePicker,
  PageHeader,
  Tag,
  Tooltip,
  Select,
  Typography,
  Spin,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import HeaderComponent from '../../components/HeaderComponent';
import moment from 'moment';
import CommentsList from './CommentsList';
import ReactTable from 'react-table';
import {
  FaPhone,
  FaUserEdit,
  FaRegComment,
  FaRegEdit,
  FaRegIdBadge,
  FaUserMd,
  FaUserPlus,
} from 'react-icons/fa';
import ReactSelect from 'react-select';
import { debounce } from '../../utils';
import {
  getOnboardingRequests,
  claimOnboardingRequest,
  updateStatusOnboardingRequest,
  initiateOnboardingVoiceCall,
  getCommentForRequest,
  addCommentForRequest,
  fetchVerticals,
  addAssociateDoctor,
  assignOnboardingRequest,
  fetchAlreadyEmpanelledReasons,
} from '../../services/api/onboarding-requests';
import { fetchDoctors } from '../../services';
import styled from 'styled-components';
import Tappable from 'react-tappable/lib/Tappable';
import Papa from 'papaparse';
import SidebarComponent  from '../../components/sidebarComponent';
import BulkUploadRequestModal from './BulkUploadRequestModal';
// import { element } from 'prop-types';

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { success, warning } = Modal;
const { Content } = Layout;
const { RangePicker } = DatePicker;

const TappableContainer = styled(Tappable)`
  margin: 10px;
`;

// The requested doctor / center is already in the Visit network. Final once set (the backend refuses any later change).
// Offered in the status modal like the other statuses, so only on claimed (pending / initiated / followUp) requests.
const ALREADY_EMPANELLED = 'alreadyEmpanelled';
class OnboardingRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showModal: false,
      showBulkUploadModal: false,
      showUpdateOpdModal: false,
      showConfirmModal: false,
      showStatusModal: false,
      commentError: false,
      reasonError: false,
      showAssociateDoctorModal: false,
      modalHeader: '',
      newStatusComment:'',
      showSuccessClaimModal: false,
      successClaimRow: null,
      successClaimReason: '',
      successClaimSaving: false,
      modalBody: '',
      bgColor: '',
      data: [],
      dataForCsv: [],
      pageSize: 10,
      pages: 0,
      totalHits: '',
      filtered: [],
      details: [],
      comments: [],
      userPhone: '',
      commentsDetails: [],
      selectedStatus: [],
      verticalOptions: [],
      fetchingDoctors: [],
      fetchedDoctors: [],
      doctorsValue: '',
      isSidebarOpen:true,
      statusOptions: [
       //{ value: 'success', label: 'Success' },
        { value: 'success', label: 'Success'},
        { value: 'invalid', label: 'Invalid' },
        { value: 'failed', label: 'Failed' },
        { value: 'followUp', label: 'Follow-up' },
        { value: 'initiated', label: 'Initiate' },
        { value: ALREADY_EMPANELLED, label: 'Already Empanelled' },
      ],
      selectedReason: null,
      reasonOptionsForFaield: [
        {
          value: 'reason-1',
          label: 'We were not able to establish contact with the centre.',
        },
        {
          value: 'reason-2',
          label: 'The centre denied for cashless facilitation via third party.',
        },
        {
          value: 'reason-3',
          label:
            'The centre does not have any online mode, available for payments.',
        }, {
          value: 'reason-4',
          label:
            'Reception staff denied to conncet with the Authorised person.',
        }, {
          value: 'reason-5',
          label:
            'Center denied to discuss over call and not giving any availability to meet F2F discussion.',
        }, {
          value: 'reason-6',
          label:
            'Failed Due Diligence.',
        }, {
          value: 'reason-7',
          label:
            'After Taking multiple followUp center is not responding.',
        },
        { value: 'other', label: 'other' },
      ],
      reasonOptionsForInvailed: [
        {
          value: 'reason-1',
          label: 'Duplicate request received.',
        },
        {
          value: 'reason-2',
          label: 'Incomplete or wrong information.',
        },
        {
          value: 'reason-3',
          label:
            'Information shared are not valid.',
        },
        {
          value: 'reason-4',
          label:
            'Both Centre and Doctor are already onboarded with yes.',
        },
        
        { value: 'other', label: 'other' },
      ],
      // admin assignment of an unclaimed / pending / initiated / followUp request
      showAssignModal: false,
      assignDetails: {},
      assigneeId: undefined,
      assigning: false,
      // alreadyEmpanelled: reasons come from the backend (GET operator/already-empanelled-reasons); the one with
      // doctorIdRequired / centerIdRequired say which existing ids a reason needs (CAT 3: both, CAT 4: center, CAT 5: doctor)
      alreadyEmpanelledReasons: [],
      alreadyEmpanelledDoctorId: '',
      alreadyEmpanelledCenterId: '',
      doctorCenterError: false,
    };
    this.fetchDataWithDebounce = debounce(this.fetchData, 300);
    this.debouncedFetchDoctors = debounce(this.onSearchDoctor, 600);
  }

  toggleSidebar = () => {
    this.setState((prevState) => ({
      isSidebarOpen: !prevState.isSidebarOpen,
    }));
  };

  tableColumns = [
    {
      accessor: 'requestId',
      filterable: true,
      Header: 'Request Id',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
     {
      accessor: 'source',
      Header: 'Source',
      filterable: true,
      width: 150,
      filterMethod: (filter, row) => {
        return row.source === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'User App'}
          >
            <option value="all">all</option>
            <option value="User App">User App</option>
            <option value="Reimbursement">Reimbursement</option>
            <option value="Digitisation">Digitisation</option>
            <option value="ACM">ACM</option>
            <option value="Support">Support</option>
            <option value="Network Agent">Network Agent</option>
           <option value="Physio Center Visit">Physio Center Visit</option>
            <option value="Physio Home Visit">Physio Home Visit</option>
          </select>
        );
      },
    },
    {
      accessor: 'category',
      filterable: true,
      Header: 'Category',
      width: 100,
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="all">All</option>
            <option value="Cat 1">Cat 1</option>
            <option value="Cat 2">Cat 2</option>
          </select>
        );
      },
      filterMethod: (filter, row) => {
        if (filter.value === 'all') return true;
        return row.category === filter.value;
      },
      Cell: (row) => {
        if (!row.original.category) return <span>-</span>;
        const color = row.original.category === 'Cat 1' ? 'red' : 'orange';
        return <Tag color={color}>{row.original.category}</Tag>;
      },
    },
    {
      accessor: 'riType',
      filterable: true,
      Header: 'RI Type',
      width: 110,
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="all">All</option>
            <option value="consult">Consult</option>
            <option value="dental">Dental</option>
            <option value="vaccine">Vaccine</option>
          </select>
        );
      },
      filterMethod: (filter, row) => {
        if (filter.value === 'all') return true;
        return row.riType === filter.value;
      },
      Cell: (row) => {
        if (!row.original.riType) return <span>-</span>;
        return <Tag color="purple">{row.original.riType}</Tag>;
      },
    },
    {
      accessor: 'physioCoverage',
      Header: 'Physio Policy Covered',
      filterable: true,
      sortable: false,
      width: 170,
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : ''}
          >
            <option value="">All</option>
            <option value="1">Covered</option>
            <option value="0">Not Covered</option>
          </select>
        );
      },
      Cell: (row) => row.original.physioCoverage || '-',
    },
    {
      accessor: 'associateName',
      sortable: true,
      filterable: true,
      Header: 'Associate Name',
      width: 200,
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },

    },
    {
      accessor: 'userName',
      sortable: true,
      filterable: true,
      Header: 'User Name',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
      Cell: (row) => {
        return (
          <Col>
            {row.original.userName}
            {row.original.source !== 'Reimbursement' && (
              <TappableContainer>
                {row.original.userName && <FaPhone
                  color="green"
                  onClick={() =>
                    this.showConfirmModal(row, row.original.userPhone)
                  }
                />}
              </TappableContainer>
            )}
          </Col>
        );
      },
    },
    {
      accessor: 'userPhone',
      sortable: true,
      filterable: true,
      Header: 'Phone Number',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'sponsorName',
      sortable: true,
      filterable: true,
      Header: 'Sponsor Name',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'doctorName',
      filterable: true,
      Header: 'Doctor & Centre',
      Filter: ({ filter, onChange }) => {
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
      Cell: (row) => {
        return (
          <Col>
            <div><strong>Dr:</strong> {row.original.doctorName || 'NA'}</div>
            <div><strong>Centre:</strong> {row.original.center || 'NA'}</div>
          </Col>
        );
      },
    },
    {
      accessor: 'vertical',
      sortable: true,
      filterable: true,
      Header: 'Vertical',
      filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        return row.status === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="all">All Onboardings</option>
            {this.fetchVerticalOptions()}
          </select>
        );
      },
    },

    {
      accessor: 'centerPhone',
      sortable: true,
      filterable: true,
      Header: 'Center Phone Number',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
      Cell: (row) => {
        // console.log({ row });
        return (
          <Col>
            {row.original.centerPhone}
            <TappableContainer>
              <FaPhone
                color="green"
                onClick={() =>
                  this.showConfirmModal(row, row.original.centerPhone)
                }
              />
            </TappableContainer>
          </Col>
        );
      },
    },
    {
      accessor: 'location',
      filterable: true,
      Header: 'Location',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'city',
      filterable: true,
      Header: 'City',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'state',
      filterable: true,
      Header: 'State',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'zone',
      filterable: false,
      Header: 'Zone',
    },
    {
      accessor: 'appointmentDate',
      filterable: true,
      Header: 'Appointment Date',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <RangePicker
            onChange={(date, dateString) => {
              this.onDateChanged(date, dateString, onChange);
            }}
          />
        );
      },
      Cell: (row) => {
        if (row.original.source === 'Reimbursement') {
          return <span>NA</span>;
        }
        return <span>{row.original.appointmentDate || ''}</span>;
      },
    },
    {
      accessor: 'requestDate',
      filterable: true,
      Header: 'Request Date',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <RangePicker
            onChange={(date, dateString) => {
              this.onDateChanged(date, dateString, onChange);
            }}
          />
        );
      },
    },
    {
      accessor: 'claimedBy',
      sortable: true,
      filterable: true,
      Header: 'Claimed By',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'status',
      Header: 'Status',
      filterable: true,
      filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        return row.status === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="unclaimed">Unclaimed</option>
            <option value="pending">Pending</option>
            <option value="success">Success</option>
            <option value="invalid">Invalid</option>
            <option value="failed">Failed</option>
            <option value="followUp">Follow Up</option>
            <option value="initiated">Initiated</option>
            <option value={ALREADY_EMPANELLED}>Already Empanelled</option>
            <option value="all">All Onboardings</option>
          </select>
        );
      },
      Cell: (row) =>
        row.original.status === 'unclaimed' ? (
          <Tag color="geekblue">{row.original.status}</Tag>
        ) : row.original.status === 'pending' ? (
          <Tag color="red">{row.original.status}</Tag>
        ) : row.original.status === 'success' ? (
          <Tag color="cyan">{row.original.status}</Tag>
        ) : row.original.status === 'invalid' ? (
          <Tag color="volcano">{row.original.status}</Tag>
        ) : row.original.status === 'failed' ? (
          <Tag color="magenta">{row.original.status}</Tag>
        ) : row.original.status === 'followUp' ? (
          <Tag color="yellow">{row.original.status}</Tag>
        ) : row.original.status === 'initiated' ? (
          <Tag color="green">{row.original.status}</Tag>
        ) : row.original.status === ALREADY_EMPANELLED ? (
          <Tag color="purple">{row.original.status}</Tag>
        ) : (
          <Tag color="cyan">{row.original.status}</Tag>
        ),
    },
    {
      accessor: 'statusRemark',
     // sortable: true,
      //filterable: true,
      Header: 'Status Remark',
      Filter: ({ filter, onChange }) => {
        // console.log({ row });
        return (
          <input
            placeholder="Search..."
            value={filter ? filter.value : ''}
            onChange={(event) => onChange(event.target.value)}
          />
        );
      },
    },
    {
      accessor: 'uniqueClaimCount',
      Header: 'Claims Registered',
    },
    {
      accessor: 'uniqueUserCount',
      Header: 'Users Visited',
    },
    {
      accessor: 'actions',
      sortable: false,
      filterable: false,
      Header: 'Actions',
      Cell: (row) => {
        // console.log({ row });
        return (
          <Col>
            {row.original.status === 'success' && !this.isAdmin() ? (
              <Tooltip placement="top" title="Only admins can claim a successful request">
                <TappableContainer>
                  <FaUserEdit
                    style={{ color: '#aaa', cursor: 'not-allowed' }}
                    size="25"
                  />
                </TappableContainer>
              </Tooltip>
            ) : (
              <Tooltip placement="top" title="Claim">
                <TappableContainer>
                  <FaUserEdit
                    style={{ color: '#017bfe' }}
                    onClick={() =>
                      row.original.status === 'success'
                        ? this.openSuccessClaimModal(row)
                        : this.claimThisRequest(row)
                    }
                    size="25"
                  />
                </TappableContainer>
              </Tooltip>
            )}
            <Tooltip placement="topLeft" title="Comment">
              <TappableContainer>
                <FaRegComment
                  style={{ color: '#017bfe' }}
                  onClick={() => this.openComments(row)}
                  size="25"
                />
              </TappableContainer>
            </Tooltip>
            <br />
            {row.original.status === 'pending' ||
            row.original.status === 'initiated' ||
            row.original.status === 'followUp' ? (
              <Tooltip placement="bottom" title="Status Update">
                <TappableContainer>
                  <FaRegEdit
                    style={{ color: '#017bfe' }}
                    onClick={() => this.showStatusModal(row)}
                    size="25"
                  />
                </TappableContainer>
              </Tooltip>
            ) : (
              <Tooltip placement="bottom" title="Status Update">
                <TappableContainer>
                  <FaRegEdit size="25" />
                </TappableContainer>
              </Tooltip>
            )}
            <Tooltip placement="bottomLeft" title="Associate Doctor">
              <TappableContainer>
                <FaRegIdBadge
                  style={{ color: '#017bfe' }}
                  onClick={() => this.openAssociateDoctor(row)}
                  size="25"
                />
              </TappableContainer>
            </Tooltip>
            <br />
            {row.original.doctorId ? (
              <Tooltip placement="bottom" title="Show Doctor">
                <TappableContainer>
                  <FaUserMd
                    style={{ color: '#017bfe' }}
                    onClick={() => {
                      // Navigate to doctor profile page
                      this.props.history.push(
                        `/doctor-profile/${row.original.doctorId}`
                      );
                    }}
                    size="25"
                  />
                </TappableContainer>
              </Tooltip>
            ) : (
              <Tooltip placement="bottom" title="Show Doctor">
                <TappableContainer>
                  <FaUserMd size="25" />
                </TappableContainer>
              </Tooltip>
            )}
            {/* admins only; assignable only while the request is unclaimed / pending / initiated / followUp
                (same list as the backend's ASSIGNABLE_STATUSES; an unclaimed request moves to pending) */}
            {this.isAdmin() &&
              (['unclaimed', 'pending', 'initiated', 'followUp'].includes(row.original.status) ? (
                <Tooltip placement="bottom" title="Assign">
                  <TappableContainer>
                    <FaUserPlus
                      style={{ color: '#017bfe' }}
                      onClick={() => this.openAssignModal(row)}
                      size="25"
                    />
                  </TappableContainer>
                </Tooltip>
              ) : (
                <Tooltip
                  placement="bottom"
                  title="Only unclaimed, pending, initiated and follow-up requests can be assigned"
                >
                  <TappableContainer>
                    <FaUserPlus size="25" />
                  </TappableContainer>
                </Tooltip>
              ))}
          </Col>
        );
      },
    },
  ];


  componentDidMount() {
    fetchVerticals().then((result) => {
      console.log({ result }, 'fetchedVerticals');
      this.setState({ verticalOptions: result.body.data });
    });
    this.loadAlreadyEmpanelledReasons();
  }
  fetchVerticalOptions = () => {
    const selections = [];
    this.state.verticalOptions.forEach((element) => {
      selections.push(
        <option value={element.verticalName}>{element.verticalName}</option>
      );
    });
    return selections;
  };
  onDateChanged = (date, dateString, onChange) => {
    console.log('end date changed', { date, dateString });
    const result = [];
    if (dateString[0].length && dateString[1].length) {
      const startTimestamp =
        moment(dateString[0], 'YYYY-MM-DD').valueOf() / 1000;
      const endTimestamp = moment(dateString[1], 'YYYY-MM-DD').valueOf() / 1000;
      result.push(startTimestamp);
      result.push(endTimestamp);
      onChange(result);
    } else {
      onChange(null);
    }
  };
  showStatusModal = (row) => {
    console.log({ row }, '[showStatusModal]');
    this.setState({
      showStatusModal: true,
      statusDetails: row.original,
      // start clean: a status / reason left from the previous request must not carry over
      selectedStatus: [],
      selectedReason: null,
      otherReason: '',
      reasonError: false,
      ...this.emptyAlreadyEmpanelledFields(),
    });
  };
  onSearchDoctor = (value) => {
    this.setState({ fetchingDoctors: true });
    if (value.trim() === '') {
      this.setState({
        fetchedDoctors: [],
        fetchingDoctors: false,
      });
      return;
    }
    fetchDoctors(value)
      .then((res) => {
        console.log({ res }, 'Search Doctor');
        if (res.result.length === 1) {
          this.setState({
            doctorsValue: res.result[0].doctorName,
          });
        }
        this.setState({
          fetchedDoctors: res.result.map((ele) => ({
            key: ele.doctorId,
            label: `${ele.doctorName}-${ele.verticalName}`,
            ...ele,
          })),
        });
      })
      .finally(() => {
        this.setState({
          fetchingDoctors: false,
        });
      });
  };

  showConfirmModal = (row, phone) => {
    console.log({ row });
    this.setState({
      showConfirmModal: true,
      userPhone: phone,
    });
  };
  handleOkConfirm = (e) => {
    const body = {
      userPhone: this.state.userPhone,
    };
    initiateOnboardingVoiceCall(body)
      .then((result) => {
        console.log({ result });
        if (result.body.message === 'success') {
          this.setState({
            showConfirmModal: false,
          });
          this.fetchTableData();
        } else {
          alert('unable to claim this request');
        }
      })
      .catch((err) => {
        console.log(err);
        alert('Error in claiming request');
      });
  };
  handleChangeStatus = (selectedStatus) => {
    // each status has its own reason list, so a reason picked for the previous status must not be sent with this one
    this.setState({
      selectedStatus,
      selectedReason: null,
      otherReason: '',
      reasonError: false,
      ...this.emptyAlreadyEmpanelledFields(),
    });
    console.log(`Option selected:`, selectedStatus);
  };
 
  handleChangeReason = (selectedReason) => {
    this.setState({ selectedReason });
    this.setState({ reasonError: false, ...this.emptyAlreadyEmpanelledFields() });

  };

  handleOk = (e) => {
    const body = {
      requestId: this.state.statusDetails.requestId,
      status: this.state.selectedStatus.value,
    };
    
    if (this.state.selectedReason) {
      if (this.state.selectedReason.value === 'other') {
        body.reason = this.state.otherReason;
      } else {
        body.reason = this.state.selectedReason.label;
      }
    }
      if (!this.state.newStatusComment.trim()) {
        // Both comment and other reason are empty
        this.setState({ commentError: true });
        return;
      }

    if (!this.state.selectedReason && (this.state.selectedStatus.value === 'failed' || this.state.selectedStatus.value === 'invalid' || this.state.selectedStatus.value === ALREADY_EMPANELLED)) {
      this.setState({ reasonError: true});
      return;
    }
    if (this.state.selectedStatus.value === ALREADY_EMPANELLED && !this.addAlreadyEmpanelledIds(body)) {
      return;
    }

    const { newStatusComment } = this.state;
    if (newStatusComment && newStatusComment.trim().length === 0) {
      //alert('Please add necessary comment to change status for this request');
      return;
    }
    if (this.state.savingComment) {
      return;
    }
    this.setState({ savingComment: true });

    const bodyToSaveComment = {
      requestId: this.state.statusDetails.requestId,
      comment: newStatusComment.trim(),
      userId: this.props.user.userId,
    };

    //  addCommentForRequest(bodyToSaveComment)
    //     .then((response) => {
    //       this.setState({
    //         newStatusComment: '',
    //         savingComment: false,
    //       });
    //     })
    //     .catch( (err) => {
    //       console.log(err);
    //       this.setState({ savingComment: false });
    //     });

    // updateStatusOnboardingRequest(body)
    //   .then((result) => {
    //     console.log({ result });
    //     if (result.body.message === 'success') {
    //       this.setState({
    //         showStatusModal: false,
    //         otherReason: '',
    //         selectedReason: null,
    //       });
    //       const modal = success({
    //         title: 'Success',
    //         content: `Marked Process.`,
    //         onOk: () => {
    //           this.fetchTableData();
    //         },
    //       });
    //     } else {
    //       alert('unable to change status for this request');
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     alert('Error in changing status request');
    //   });

    updateStatusOnboardingRequest(body)
      .then((result) => {
        console.log({ result });

        if (result.body.message === 'success') {
          // Update the status successfully
          return addCommentForRequest(bodyToSaveComment);
        } else {
          alert('unable to change status for this request');
          throw new Error('Failed to update status');
        }
      })
      .then(() => {
        // Comment added successfully
        this.setState({
          newStatusComment: '',
          savingComment: false,
          showStatusModal: false,
          otherReason: '',
          selectedReason: null,
        });

        const modal = success({
          title: 'Success',
          content: 'Marked Process.',
          onOk: () => {
            this.fetchTableData();
          },
        });
      })
      .catch((err) => {
        console.log(err);
        alert(this.statusErrorMessage(err));
        this.setState({ savingComment: false });
      });
  };

  handleCancel = (e) => {
    this.setState({
      showConfirmModal: false,
      showStatusModal: false,
      otherReason: '',
      selectedReason: null,
      associateDoctorId: '',
      showAssociateDoctorModal: false,
      doctorsValue: '',
      fetchedDoctors: [],
      ...this.emptyAlreadyEmpanelledFields(),
    });
  };
  claimThisRequest = (request) => {
    console.log(request);
    const body = {
      requestId: request.original.requestId,
      userId: this.props.user.userId,
    };
    claimOnboardingRequest(body)
      .then((result) => {
        console.log({ result });
        if (result.body.message === 'success') {
          const modal = success({
            title: 'Success',
            content: `Request claimed.`,
            onOk: () => {
              this.fetchTableData();
            },
          });
        } else {
          alert('unable to claim this request');
        }
      })
      .catch((err) => {
        console.log(err);
        alert('Error in claiming request');
      });
  };
  // Claiming an already-successful request (admins only) needs a remark, saved as a request comment
  openSuccessClaimModal = (row) => {
    this.setState({
      showSuccessClaimModal: true,
      successClaimRow: row,
      successClaimReason: '',
      successClaimSaving: false,
    });
  };
  closeSuccessClaimModal = () => {
    this.setState({
      showSuccessClaimModal: false,
      successClaimRow: null,
      successClaimReason: '',
      successClaimSaving: false,
    });
  };
  submitSuccessClaim = () => {
    const { successClaimRow, successClaimReason, successClaimSaving } = this.state;
    const reason = successClaimReason.trim();
    if (!reason || successClaimSaving || !this.isAdmin()) {
      return;
    }
    this.setState({ successClaimSaving: true });
    addCommentForRequest({
      requestId: successClaimRow.original.requestId,
      comment: `Claimed successful request. Reason: ${reason}`,
      userId: this.props.user.userId,
    })
      .then(() => {
        this.closeSuccessClaimModal();
        this.claimThisRequest(successClaimRow);
      })
      .catch((err) => {
        console.log(err);
        this.setState({ successClaimSaving: false });
        alert('Unable to save the remark, request not claimed');
      });
  };
  // Associate Doctor
  openAssociateDoctor = (row) => {
    if (row.original.doctorId) {
      this.onSearchDoctor(row.original.doctorId.toString());
    }
    this.setState({
      showAssociateDoctorModal: true,
      associateDoctorDetails: row.original,
    });
  };
  handleChangeAssociateDoctor = (e) => {
    this.setState({ associateDoctorId: e, doctorsValue: e });
  };
  handleAssociateDoctorOk = () => {
    const { associateDoctorId, associateDoctorDetails } = this.state;
    if (associateDoctorId) {
      const body = {
        associateDoctorId: associateDoctorId,
        requestId: associateDoctorDetails.requestId,
      };
      addAssociateDoctor(body)
        .then((result) => {
          console.log({ result });
          if (result.body.message === 'success') {
            this.setState({ associateDoctorId: '' });
            const modal = success({
              title: 'Success',
              content: 'Doctor associated successfully.',
              onOk: () => {
                this.fetchTableData();
                this.setState({
                  associateDoctorId: '',
                  showAssociateDoctorModal: false,
                  doctorsValue: '',
                  fetchedDoctors: [],
                });
              },
            });
          } else {
            this.setState({
              associateDoctorId: '',
              showAssociateDoctorModal: false,
            });
            alert('unable to associate doctor.');
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            associateDoctorId: '',
            showAssociateDoctorModal: false,
          });
          alert('Error in associate doctor.');
        });
    } else {
      const modal = warning({
        title: 'warning',
        content: 'Doctor Id is required.',
        onOk: () => {},
      });
    }
  };
  // Comments
  openComments = (row) => {
    this.setState({
      showCommentModal: true,
      commentsDetails: row.original,
    });
    this.fetchComments(row.original.requestId);
  };
  toggleDialog = () => {
    this.setState({
      showCommentModal: false,
      comments: [],
      commentsDetails: [],
    });
  };
  saveComment = () => {
    const { newComment } = this.state;
    if (newComment && newComment.trim().length === 0) {
      return;
    }
    if (this.state.savingComment) {
      return;
    }
    this.setState({ savingComment: true });
    const body = {
      requestId: this.state.commentsDetails.requestId,
      comment: newComment.trim(),
      userId: this.props.user.userId,
    };

    addCommentForRequest(body)
      .then((response) => {
        this.fetchComments();
        this.setState({
          newComment: '',
          savingComment: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ savingComment: false });
      });
  };
  fetchComments = (requestId) => {
    const params = {
      requestId: this.state.commentsDetails.requestId || requestId,
    };
    console.log({ params });
    getCommentForRequest(params)
      .then((response) => {
        this.setState({
          comments: response.body.comments,
          loading: false,
        });
      })
      .catch((err) => {
        console.error('Error in fetching', err);
      });
  };
  // Fetch Table Data
  onFetchData = (state) => {
    let orderBy, orderDir;
    if (state.sorted.length > 0) {
      orderBy = state.sorted[0].id;
      orderDir = state.sorted[0].desc ? 'desc' : 'asc';
    } else {
      orderBy = 'requestId';
      orderDir = 'DESC';
    }
    this.setState(
      {
        pageSize: state.pageSize,
        page: state.page,
        orderBy,
        orderDir,
      },
      this.fetchTableData
    );
  };

  downloadCsv = () => {

    this.setState({
      loading: true,
    });
     const params = {
      rowsPerPage: 1000000,
      page: this.state.page,
      orderBy: this.state.orderBy,
      orderDir: this.state.orderDir,
    };
    if (this.state.filtered.length !== 0) {
      this.state.filtered.forEach((element) => {
        if (element.id === 'requestId') params.requestId = element.value;
        if (element.id === 'userName') params.userName = element.value;
        if (element.id === 'doctorName') params.doctorName = element.value;
        if (element.id === 'center') params.center = element.value;
        if (element.id === 'centerPhone') params.centerPhone = element.value;
        if (element.id === 'location') params.location = element.value;
        if (element.id === 'state') params.state = element.value;
        if (element.id === 'city') params.city = element.value;
        if (element.id === 'userPhone') params.userPhone = element.value;
        if (element.id === 'vertical' && element.value !== 'all')
          params.vertical = element.value;
        if (element.id === 'sponsorName') params.sponsorName = element.value;
        if (element.id === 'appointmentDate')
          params.appointmentDate = element.value;
        if (element.id === 'requestDate') params.requestDate = element.value;
        if (element.id === 'claimedBy') params.claimedBy = element.value;
        if (element.id === 'status') params.status = element.value;
        if(element.id === 'source') params.source = element.value;
        if(element.id === 'associateName') params.associateName = element.value;
        if (element.id === 'physioCoverage')
          params.physioCoverage = element.value;
      });
    }
   getOnboardingRequests(params)
      .then((responseBody) => {
        console.log({ responseBody });
        this.setState({
          loading: false,
        });
     
 
  const fields = [
   {label:"Request Id",value:"requestId"},
    {label:"Source",value:"source"},
    {label:"Physio Policy Covered",value:"physioCoverage"},
    {label:"Associate Name",value:"associateName"},
    {label:"User Name",value:"userName"},
    {label:"Sponsor Name",value:"sponsorName"},
    {label:"Doctor Name",value:"doctorName"},
    {label:"Vertical",value:"vertical"},
    {label:"Center",value:"center"},
    {label:"Center Phone Number",value:"centerPhone"},
    {label:"Location",value:"location"},
    {label:"City",value:"city"},
    {label:"State",value:"state"},
    {label:"Zone",value:"zone"},
    {label:"Appointment Date",value:"appointmentDate"},
    {label:"Request Date",value:"requestDate"},
    {label:"Claimed By",value:"claimedBy"},
    {label:"Status",value:"status"},
    {label:"Status Remark",value:"statusRemark"},
    {label:"Claims Registered",value:"uniqueClaimCount"},
    {label:"Users Visited",value:"uniqueUserCount"},
  ];

   const filteredData = responseBody.body.data.map(item => {
    const filteredItem = {};
    fields.forEach(field => {
      filteredItem[field.label] = item[field.value];
    });
    return filteredItem;
  });

  const csv = Papa.unparse(filteredData, {
    header: true
  });

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download',`${new Date().toISOString().split('T')[0]}_Pluton_data.csv`);
  document.body.appendChild(link);

  link.click();
  document.body.removeChild(link);
   })
};

  fetchTableData = () => {
    this.setState({
      loading: true,
    });
    // console.log(this.state.filtered.length, this.state.filtered[0]);

    const params = {
      rowsPerPage: this.state.pageSize,
      page: this.state.page,
      orderBy: this.state.orderBy,
      orderDir: this.state.orderDir,
    };
    if (this.state.filtered.length !== 0) {
      this.state.filtered.forEach((element) => {
        // console.log({element});
        if (element.id === 'requestId') params.requestId = element.value;
        if (element.id === 'userName') params.userName = element.value;
        if (element.id === 'doctorName') params.doctorName = element.value;
        if (element.id === 'center') params.center = element.value;
        if (element.id === 'centerPhone') params.centerPhone = element.value;
        if (element.id === 'location') params.location = element.value;
        if (element.id === 'state') params.state = element.value;
        if (element.id === 'city') params.city = element.value;
        if (element.id === 'userPhone') params.userPhone = element.value;
        if (element.id === 'vertical' && element.value !== 'all')
          params.vertical = element.value;
        if (element.id === 'sponsorName') params.sponsorName = element.value;
        if (element.id === 'appointmentDate')
          params.appointmentDate = element.value;
        if (element.id === 'requestDate') params.requestDate = element.value;
        if (element.id === 'claimedBy') params.claimedBy = element.value;
        if (element.id === 'status') params.status = element.value;
        if(element.id === 'source') params.source = element.value;
        if(element.id === 'associateName') params.associateName = element.value;
        if (element.id === 'physioCoverage')
          params.physioCoverage = element.value;
      });
    }
    // console.log(params);

    getOnboardingRequests(params)
      .then((responseBody) => {
        console.log({ responseBody });
        this.setState({
          data: responseBody.body.data,
          loading: false,
          totalHits: responseBody.body.totalHits,
          pages: Math.ceil(responseBody.body.totalHits / this.state.pageSize),
        });
      })
      .catch((err) => {
        console.log(err);
        let errorMessage = err.message;
        this.setState({
          showModal: true,
          modalHeader: 'Error',
          modalBody: `${errorMessage}.`,
          bgColor: 'bg-danger',
          loading: false,
        });
      });
  };
  onFilteredChange = (e) => {
    // console.log(e);
    this.setState({ filtered: e });
  };
  render() {
    const { fetchingDoctors, fetchedDoctors, associateDoctorId,isSidebarOpen } = this.state;
    const { history } = this.props;
    return (
      <div>
        <HeaderComponent />
        <div style={{
          display: 'flex',
        }}>
          <div style={{zIndex:1000}}>

            <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={this.toggleSidebar} />
        </div>
        <div 
        style={{ overflow:'scroll'}}>

        
        <Content className="site-layout-background"
          style={{
            background: '#f0f2f5',
          }}>
        <div 
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '24px 24px 24px 24px',


        }}>
          <div 
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignContent: 'center',
          }}>

          <PageHeader
            className="site-page-header"
            title="Onboarding Requests"
            style={{
              padding: '0px',
            }}
            />
              <div>
                <h3>
                   <Tag
          style={{
            background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(68, 93, 228, 0.1), rgba(68, 93, 228, 0.1))',
            color: '#445DE4', 
            justifyContent: 'center', 
            display: 'flex', 
            alignItems: 'center', 
            padding: '5px 10px', 
            borderRadius: '5px', 
            border: '1px solid #445DE433',
            backgroundColor: '#FFFFFF',
          }}
        >
                    Total: {this.state.totalHits + ' Requests'}
                  </Tag>
                </h3>
              </div>
      </div>
                <div  style= {{display: 'flex' ,gap:'10px'}}> 
                 <Button type="primary" 
                 style= {{backgroundColor:' #448EF7',}}
                 size="large"
                  onClick={() => {
                // Navigate to doctor profile page
                   window.open('/create-new-request', '_blank');
              }}
                 >
                  Create New Request
                </Button>
                 <Button type="primary"
                 style= {{backgroundColor:' #448EF7',}}
                 size="large"
                 onClick={() => this.setState({ showBulkUploadModal: true })}
                 >
                  Create New Request by CSV
                </Button>
                 <Button type="primary"
                 style= {{backgroundColor:' #448EF7',}}
                 size="large"
                 onClick={this.downloadCsv}
                 >
                  Download CSV
                </Button>
                </div>
</div>
          <div>
            <ReactTable
              data={this.state.data}
              columns={this.tableColumns}
              loading={this.state.loading}
              manual
              onFetchData={this.onFetchData}
              onFilteredChange={this.onFilteredChange}
              className="-striped -highlight"
              pages={this.state.pages}
              showPaginationTop
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.original.source === 'Reimbursement') {
                  return {
                    style: {
                      backgroundColor: '#fff3e0',
                      borderLeft: '4px solid #ff9800',
                    },
                  };
                }
                return {};
              }}
            />
          </div>
          <Modal
            title="Set Status"
            visible={this.state.showStatusModal}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <Row>
              <Col>
                <label>Status:</label>
              </Col>
              <Col>
                <ReactSelect
                  value={this.state.selectedStatus}
                  onChange={this.handleChangeStatus}
                  options={this.state.statusOptions}
                  id={'selectStatus'}
                />
              </Col>
            </Row>
            <Divider />
            <Row>
              <Col>
                <label>Comment:</label>
                <TextArea
                  maxLength={'255'}
                  id="comment"
                  rows="3"
                  value={this.state.newStatusComment}
                  onChange={(e) =>
                    this.setState({
                      newStatusComment: e.target.value,
                      commentError: false,
                    })
                  }
                />
                {this.state.commentError && (
                  <p style={{ color: 'red' }}>Comment cannot be empty.</p>
                )}
              </Col>
            </Row>
            <Divider />
            {this.state.selectedStatus.value === 'failed' ? (
              <Row>
                <Col>
                  <label>Reason:</label>
                </Col>
                <Col>
                  <ReactSelect
                    value={this.state.selectedReason}
                  onChange={this.handleChangeReason}
                    options={this.state.reasonOptionsForFaield}
                    id={'selectReason'}
                  />
                  {this.state.reasonError && (
                    <p style={{ color: 'red' }}>Reason cannot be empty.</p>
                  )}
                  {this.state.selectedReason &&
                  this.state.selectedReason.value === 'other' ? (
                    <TextArea
                      maxLength={'255'}
                      id="comment"
                      rows="3"
                      style={{ marginTop: '5px' }}
                      value={this.state.otherReason}
                      onChange={(e) =>
                        this.setState({ otherReason: e.target.value })
                      }
                    />
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            ) : (
              ''
            )}
            {this.state.selectedStatus.value === 'invalid' ? (
              <Row>
                <Col>
                  <label>Reason:</label>
                </Col>
                <Col>
                  <ReactSelect
                    value={this.state.selectedReason}
                    onChange={this.handleChangeReason}
                    options={this.state.reasonOptionsForInvailed}
                    id={'selectReason'}
                  />
                  {this.state.reasonError && (
                    <p style={{ color: 'red' }}>Reason cannot be empty.</p>
                  )}
                  {this.state.selectedReason &&
                    this.state.selectedReason.value === 'other' ? (
                    <TextArea
                      maxLength={'255'}
                      id="comment"
                      rows="3"
                      style={{ marginTop: '5px' }}
                      value={this.state.otherReason}
                      onChange={(e) =>
                        this.setState({ otherReason: e.target.value })
                      }
                    />
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            ) : (
              ''
            )}
            {this.state.selectedStatus.value === ALREADY_EMPANELLED
              ? this.renderAlreadyEmpanelledFields()
              : ''}
          </Modal>
          <Modal
            title="Claim successful request"
            visible={this.state.showSuccessClaimModal}
            onCancel={this.closeSuccessClaimModal}
            onOk={this.submitSuccessClaim}
            okText="Claim"
            okButtonProps={{
              disabled: !this.state.successClaimReason.trim(),
              loading: this.state.successClaimSaving,
            }}
          >
            <p>
              This request is already successful. Please give a reason for claiming it; it will be
              saved as a comment on the request.
            </p>
            <TextArea
              maxLength={255}
              rows={4}
              placeholder="Reason for claiming this successful request"
              value={this.state.successClaimReason}
              onChange={(e) => this.setState({ successClaimReason: e.target.value })}
            />
          </Modal>
          <Modal
            title="Comments"
            visible={this.state.showCommentModal}
            onCancel={this.toggleDialog}
            onOk={this.toggleDialog}
          >
            <Row>
              <Col span={8} className="col">
                <h5>RequestId: {this.state.commentsDetails.requestId}</h5>
              </Col>
              <Col span={8} className="col">
                <h5>DoctorName: {this.state.commentsDetails.doctorName}</h5>
              </Col>
            </Row>
            {this.state.loading ? (
              <h4>Loading</h4>
            ) : (
              <CommentsList comments={this.state.comments} />
            )}
            <Divider />
            <Row>
              <Row>
                <Col>
                  <Row>
                    <TextArea
                      maxLength={'255'}
                      id="comment"
                      rows="3"
                      value={this.state.newComment}
                      onChange={(e) =>
                        this.setState({ newComment: e.target.value })
                      }
                    />
                    <Button onClick={this.saveComment}>Send</Button>
                  </Row>
                </Col>
              </Row>
            </Row>
          </Modal>
          <Modal
            title="Call User?"
            visible={this.state.showConfirmModal}
            onOk={this.handleOkConfirm}
            onCancel={this.handleCancel}
          >
            Are you sure you want to call user? <br />
            Phone Number: {this.state.userPhone}
          </Modal>

          <Modal
            title="Associate Doctor"
            visible={this.state.showAssociateDoctorModal}
            onOk={this.handleAssociateDoctorOk}
            onCancel={this.handleCancel}
          >
            <Row>
              <label>Doctor:</label>
              <Select
                showSearch
                style={{ width: '80%', marginLeft: '10px' }}
                dropdownMatchSelectWidth={false}
                notFoundContent={fetchingDoctors ? <Spin size="small" /> : null}
                defaultActiveFirstOption={false}
                showArrow={false}
                value={this.state.doctorsValue}
                filterOption={false}
                placeholder="Doctors"
                onSearch={this.debouncedFetchDoctors}
                onChange={this.handleChangeAssociateDoctor}
              >
                {fetchedDoctors.map((d) => (
                  <Option key={d.key}>
                    <Row>{d.label}</Row>
                    <Row>
                      {d.centers.map((center) => (
                        <Col>
                          <Text
                            code
                          >{`${center.hospitalName}, ${center.locality}`}</Text>
                          <Text code>
                            Is Active - {center.isActive ? 'Yes' : 'No'}
                          </Text>
                          <Text code>Status - {center.status}</Text>
                        </Col>
                      ))}
                    </Row>
                  </Option>
                ))}
              </Select>
            </Row>
            <Button
              onClick={() => {
                // Navigate to doctor profile page
                if (associateDoctorId) {
                  history.push(`/doctor-profile/${associateDoctorId}`);
                }
              }}
              style={{ margin: '10px' }}
            >
              Show Doctor Details
            </Button>
          </Modal>
          <BulkUploadRequestModal
            visible={this.state.showBulkUploadModal}
            onClose={() => this.setState({ showBulkUploadModal: false })}
            onSuccess={() => this.fetchTableData()}
          />
          <Modal
            title="Assign Request"
            visible={this.state.showAssignModal}
            onOk={this.handleAssignOk}
            onCancel={this.closeAssignModal}
            okText="Assign"
            confirmLoading={this.state.assigning}
            destroyOnClose
          >
            <Row>
              <Text strong>Request Id:</Text> {this.state.assignDetails.requestId}
            </Row>
            <Row style={{ marginTop: '8px' }}>
              <Text strong>Currently claimed by:</Text>{' '}
              {this.state.assignDetails.claimedBy || '-'}
            </Row>
            <Divider />
            <Row>
              <label>Assign to:</label>
              <Select
                showSearch
                style={{ width: '80%', marginLeft: '10px' }}
                placeholder="Select team member"
                value={this.state.assigneeId}
                onChange={(assigneeId) => this.setState({ assigneeId })}
                filterOption={(input, option) =>
                  String(option.props.children)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {/* active members only, same rule as the backend (0 / NULL = inactive); if `active` isn't in the
                    operator/all response yet (older backend), everyone is listed and the backend still validates */}
                {(this.props.operators || [])
                  .filter((operator) => operator.active === undefined || Boolean(operator.active))
                  .map((operator) => (
                    <Option key={operator.operatorId} value={operator.operatorId}>
                      {operator.name}
                    </Option>
                  ))}
              </Select>
            </Row>
          </Modal>
        </Content>
   
      </div>
        </div>
        </div>
    );
  }

  // Assignment (admins only): onboarding_users.user_type, from the operator list HeaderComponent loads into redux
  isAdmin = () => {
    const { userDetails } = this.props;
    return Boolean(userDetails && userDetails.userType === 'admin');
  };

  openAssignModal = (row) => {
    this.setState({
      showAssignModal: true,
      assignDetails: row.original,
      assigneeId: undefined,
    });
  };

  closeAssignModal = () => {
    this.setState({
      showAssignModal: false,
      assignDetails: {},
      assigneeId: undefined,
      assigning: false,
    });
  };

  handleAssignOk = () => {
    const { assigneeId, assignDetails } = this.state;
    if (!assigneeId) {
      warning({ title: 'Warning', content: 'Please select a team member.' });
      return;
    }
    this.setState({ assigning: true });
    assignOnboardingRequest({
      requestId: assignDetails.requestId,
      assigneeId,
    })
      .then((result) => {
        const assignee = result.body.data && result.body.data.assignee;
        this.closeAssignModal();
        // refresh right away, so the row shows the new assignee however the dialog is closed
        this.fetchTableData();
        success({
          title: 'Success',
          content: `Request ${assignDetails.requestId} assigned to ${assignee ? assignee.name : 'the selected member'}.`,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ assigning: false });
        // 400 / 403 / 404 / 409 carry a readable errorMessage
        const errorMessage =
          (err && err.response && err.response.data && err.response.data.errorMessage) ||
          'Unable to assign this request.';
        warning({ title: 'Could not assign', content: errorMessage });
      });
  };

  // ---- alreadyEmpanelled ----
  loadAlreadyEmpanelledReasons = () => {
    fetchAlreadyEmpanelledReasons()
      .then((result) => {
        const reasons = (result.body.data && result.body.data.reasons) || [];
        this.setState({
          alreadyEmpanelledReasons: reasons.map((reason) => ({
            value: reason.code,
            label: reason.label,
            doctorIdRequired: Boolean(reason.doctorIdRequired),
            centerIdRequired: Boolean(reason.centerIdRequired),
          })),
        });
      })
      .catch((err) => {
        console.log(err, '[loadAlreadyEmpanelledReasons]');
      });
  };

  emptyAlreadyEmpanelledFields = () => ({
    alreadyEmpanelledDoctorId: '',
    alreadyEmpanelledCenterId: '',
    doctorCenterError: false,
  });

  // which existing ids the selected reason needs
  alreadyEmpanelledRequiredIds = () => {
    const reason = this.state.selectedReason || {};
    return { doctor: Boolean(reason.doctorIdRequired), center: Boolean(reason.centerIdRequired) };
  };

  // adds the ids the selected reason needs to the status body. false = a needed id is missing or invalid
  addAlreadyEmpanelledIds = (body) => {
    const required = this.alreadyEmpanelledRequiredIds();
    const isValidId = (id) => Number.isInteger(id) && id > 0;
    const doctorId = Number(this.state.alreadyEmpanelledDoctorId);
    const centerId = Number(this.state.alreadyEmpanelledCenterId);
    if ((required.doctor && !isValidId(doctorId)) || (required.center && !isValidId(centerId))) {
      this.setState({ doctorCenterError: true });
      return false;
    }
    if (required.doctor) {
      body.doctorId = doctorId;
    }
    if (required.center) {
      body.centerId = centerId;
    }
    return true;
  };

  // the error and the rule shown under the id inputs, for the ids the reason needs
  alreadyEmpanelledIdTexts = (required) => {
    if (required.doctor && required.center) {
      return { error: 'Enter the existing doctor id and center id.', hint: 'The doctor must have an active practice at this center.' };
    }
    if (required.center) {
      return { error: 'Enter the existing center id.', hint: null };
    }
    return { error: 'Enter the existing doctor id.', hint: 'The doctor must have an active practice at a center.' };
  };

  // 404 / 409 / 400 (no practice) carry errorMessage; a validation 400 carries err: { field: { msg } }
  statusErrorMessage = (err) => {
    const data = err && err.response && err.response.data;
    if (data && data.errorMessage) {
      return data.errorMessage;
    }
    if (data && data.err) {
      return Object.keys(data.err).map((field) => data.err[field].msg).join('\n');
    }
    return 'Error in changing status request';
  };

  // only the inputs the selected reason needs (CAT 3: both, CAT 4: center, CAT 5: doctor); nothing for the others
  renderAlreadyEmpanelledIdInputs = () => {
    const required = this.alreadyEmpanelledRequiredIds();
    if (!required.doctor && !required.center) {
      return null;
    }
    const texts = this.alreadyEmpanelledIdTexts(required);
    return (
      <Row gutter={8} style={{ marginTop: '10px' }}>
        {required.doctor ? (
          <Col span={12}>
            <label>Doctor Id:</label>
            <Input
              type="number"
              min={1}
              placeholder="Existing doctor id"
              value={this.state.alreadyEmpanelledDoctorId}
              onChange={(e) =>
                this.setState({ alreadyEmpanelledDoctorId: e.target.value, doctorCenterError: false })
              }
            />
          </Col>
        ) : null}
        {required.center ? (
          <Col span={12}>
            <label>Center Id:</label>
            <Input
              type="number"
              min={1}
              placeholder="Existing center id"
              value={this.state.alreadyEmpanelledCenterId}
              onChange={(e) =>
                this.setState({ alreadyEmpanelledCenterId: e.target.value, doctorCenterError: false })
              }
            />
          </Col>
        ) : null}
        <Col span={24}>
          {this.state.doctorCenterError && <p style={{ color: 'red' }}>{texts.error}</p>}
          {texts.hint && <p style={{ fontSize: '12px', marginTop: '5px' }}>{texts.hint}</p>}
        </Col>
      </Row>
    );
  };

  renderAlreadyEmpanelledFields = () => (
    <Row>
      <Col>
        <label>Reason:</label>
      </Col>
      <Col>
        <ReactSelect
          value={this.state.selectedReason}
          onChange={this.handleChangeReason}
          options={this.state.alreadyEmpanelledReasons}
          id={'selectReason'}
        />
        {this.state.alreadyEmpanelledReasons.length === 0 && (
          <p style={{ color: 'red' }}>Reasons could not be loaded. Refresh the page and try again.</p>
        )}
        {this.state.reasonError && (
          <p style={{ color: 'red' }}>Reason cannot be empty.</p>
        )}
        {this.renderAlreadyEmpanelledIdInputs()}
      </Col>
    </Row>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user,
    // loaded by HeaderComponent (GET operator/all): team members for the assign dropdown, and the admin flag
    operators: state.info.operators,
    userDetails: state.info.userDetails,
  };
}

export default connect(mapStateToProps)(withRouter(OnboardingRequest));
